// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Outer container */
.view-toggle-segment {
  background: #ffffff;
  padding: 4px;
  border-radius: 10px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
}

/* Each segment item */
.view-toggle-segment .ant-segmented-item {
  background: transparent;
  border-radius: 8px;
  transition: background-color 0.2s ease;
  height: 28px !important;
}
.view-toggle-segment.ant-segmented .ant-segmented-group {
  gap: 2px !important;
}
/* Icon default state */
.view-toggle-segment .ant-segmented-item svg {
  font-size: 18px;
  color: #333;
}

/* Selected (active) segment */
.view-toggle-segment .ant-segmented-item-selected {
  background-color: #d2042d !important;
}
.view-toggle-segment .ant-segmented-thumb {
  background: #d2042d !important;
}

.view-toggle-segment .ant-segmented-item-selected svg {
  color: #ffffff !important;
}
.view-toggle-segment .ant-segmented-thumb {
  background: transparent !important;
}
.view-toggle-segment {
  height: 35px;
}
.view-toggle-segment .ant-segmented-item-label {
  padding: 3px 10px !important;
  align-items: center;
  width: auto;
}
.product-title-grid {
  color: #000;
  font-size: var(--Font-Font-Size-p, 14px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  font-family: Roboto;
}
.styling-height {
  height: 60px !important;
}
.grid-pricing-section {
  display: flex;
  gap: 10px;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
  justify-content: space-between;
}
.product-grid-diver {
  height: 60px !important;
  border-color: #b3b5b4;
}
.notify-me-grid-button {
  padding-right: 0px !important;
}
.height-styling {
  height: 50px !important;
}
.product-image-wrapper {
  width: 100% !important;
  height: 200px !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 10px;
}
.product-grid-images {
  width: 100% !important;
  overflow: hidden;
}
.carousel-image-slide {
  height: 200px;
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.product-image-wrapper .ant-carousel,
.product-image-wrapper .slick-slider,
.product-image-wrapper .slick-list,
.product-image-wrapper .slick-track {
  height: 100%;
}
.product-image-wrapper .slick-prev,
.product-image-wrapper .slick-next {
  pointer-events: auto;
}
.grid-view-dates-container {
  display: flex;
  align-items: flex-start !important;
  flex-direction: column !important;
  margin-top: 5px !important;
}
.grid-view-card {
  padding: 0px !important;
}

.product-meta-row {
  margin-top: 20px;
}

.product-meta-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.hidden-product-card {
  cursor: default;
  box-shadow: none;
  background: transparent;
  min-height: 490px !important;
}
.grid-product-title-available-state {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.grid-not-available-col {
  width: 30%;
  display: flex;
  justify-content: flex-end;
}
.grid-not-available-container {
  border-radius: 32px;
  padding-top: 7px;
  padding-right: 16px;
  padding-bottom: 7px;
  padding-left: 16px;
  gap: 8px;
  background: #fee1e7;
  justify-content: center;
}
.grid-not-available-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--Colors-Primary-500, #d2042d);
}
.grid-price-col {
  display: flex;
  gap: 5px;
  align-items: center;
}
.add-grid-views {
  display: flex;
}

.grid-view-card {
  height: 100%;
  width: 100%;
}
.grid-view-card.ant-card .ant-card-body {
  padding: 0px !important;
  border-radius: 0 0 8px 8px;
  height: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.grid-notify-button {
  margin-top: 0px !important;
}
.grid-specification-layout {
  display: flex;
  margin-top: 20px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.spec-icon-row {
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
}
.grid-bottom-add {
  display: flex;
  width: 100% !important;
  justify-content: center !important;
  align-items: center !important;
}
.grid-product-site-number {
  padding-right: 2% !important;
}
.grid-empty-view-card {
  display: flex;
  justify-content: center;
}
.available-txt-grid {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--Colors-Text-300, #5b5e5d);
}
@media (min-width: 769px) and (max-width: 1025px) {
  .grid-product-title-available-state {
    flex-direction: column !important;
    align-items: flex-start !important;
  }
  .grid-not-available-col {
    width: 100% !important;
    justify-content: flex-start !important;
  }
  .small-screen-container {
    width: 45%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .notify-me-grid-button {
    padding: 0px !important;
  }
  .grid-pricing-section {
    gap: 0px !important;
  }
  /* .add-grid-views {
    height: 100% !important;
  } */
}

@media (min-width: 1921px) and (max-width: 2560px) {
  .product-image-wrapper {
    height: 350px !important;
  }
  .carousel-image-slide {
    height: 350px;
  }
  .product-id {
    font-size: 16px !important;
  }
  .product-title-grid {
    font-size: var(--Font-Font-Size-p, 21px);
  }
  .available-txt-grid {
    font-size: 16px;
  }
  .product-availability {
    font-size: 20px;
  }
  .product-size-text {
    font-size: 20px;
  }
  .product-type {
    font-size: 20px;
  }
  .price-text {
    font-size: 28px;
  }
  .per-week {
    font-size: 18px;
  }
}
@media (min-width: 2561px) and (max-width: 3841px) {
  .product-image-wrapper {
    height: 450px !important;
  }
  .carousel-image-slide {
    height: 450px;
  }
  .product-id {
    font-size: 16px !important;
  }
  .product-title-grid {
    font-size: var(--Font-Font-Size-p, 21px);
  }
  .available-txt-grid {
    font-size: 16px;
  }
  .product-availability {
    font-size: 20px;
  }
  .product-size-text {
    font-size: 20px;
  }
  .product-type {
    font-size: 20px;
  }
  .price-text {
    font-size: 28px;
  }
  .per-week {
    font-size: 18px;
  }
}
.product-grid-stretch {
  height: 100%;
}
@media (min-width: 769px) and (max-width: 1025px) {
  .grid-side {
    padding: 50px 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/products/products-grid-view/ProductGridCard.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;EACtC,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA,uBAAuB;AACvB;EACE,eAAe;EACf,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;AACtC;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,YAAY;AACd;AACA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;;EAIE,YAAY;AACd;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,iCAAiC;EACjC,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE;IACE,iCAAiC;IACjC,kCAAkC;EACpC;EACA;IACE,sBAAsB;IACtB,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;;KAEG;AACL;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Outer container */\n.view-toggle-segment {\n  background: #ffffff;\n  padding: 4px;\n  border-radius: 10px;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);\n}\n\n/* Each segment item */\n.view-toggle-segment .ant-segmented-item {\n  background: transparent;\n  border-radius: 8px;\n  transition: background-color 0.2s ease;\n  height: 28px !important;\n}\n.view-toggle-segment.ant-segmented .ant-segmented-group {\n  gap: 2px !important;\n}\n/* Icon default state */\n.view-toggle-segment .ant-segmented-item svg {\n  font-size: 18px;\n  color: #333;\n}\n\n/* Selected (active) segment */\n.view-toggle-segment .ant-segmented-item-selected {\n  background-color: #d2042d !important;\n}\n.view-toggle-segment .ant-segmented-thumb {\n  background: #d2042d !important;\n}\n\n.view-toggle-segment .ant-segmented-item-selected svg {\n  color: #ffffff !important;\n}\n.view-toggle-segment .ant-segmented-thumb {\n  background: transparent !important;\n}\n.view-toggle-segment {\n  height: 35px;\n}\n.view-toggle-segment .ant-segmented-item-label {\n  padding: 3px 10px !important;\n  align-items: center;\n  width: auto;\n}\n.product-title-grid {\n  color: #000;\n  font-size: var(--Font-Font-Size-p, 14px);\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  font-family: Roboto;\n}\n.styling-height {\n  height: 60px !important;\n}\n.grid-pricing-section {\n  display: flex;\n  gap: 10px;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 20px;\n  justify-content: space-between;\n}\n.product-grid-diver {\n  height: 60px !important;\n  border-color: #b3b5b4;\n}\n.notify-me-grid-button {\n  padding-right: 0px !important;\n}\n.height-styling {\n  height: 50px !important;\n}\n.product-image-wrapper {\n  width: 100% !important;\n  height: 200px !important;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: 10px;\n}\n.product-grid-images {\n  width: 100% !important;\n  overflow: hidden;\n}\n.carousel-image-slide {\n  height: 200px;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n}\n.product-image-wrapper .ant-carousel,\n.product-image-wrapper .slick-slider,\n.product-image-wrapper .slick-list,\n.product-image-wrapper .slick-track {\n  height: 100%;\n}\n.product-image-wrapper .slick-prev,\n.product-image-wrapper .slick-next {\n  pointer-events: auto;\n}\n.grid-view-dates-container {\n  display: flex;\n  align-items: flex-start !important;\n  flex-direction: column !important;\n  margin-top: 5px !important;\n}\n.grid-view-card {\n  padding: 0px !important;\n}\n\n.product-meta-row {\n  margin-top: 20px;\n}\n\n.product-meta-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n.hidden-product-card {\n  cursor: default;\n  box-shadow: none;\n  background: transparent;\n  min-height: 490px !important;\n}\n.grid-product-title-available-state {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n}\n.grid-not-available-col {\n  width: 30%;\n  display: flex;\n  justify-content: flex-end;\n}\n.grid-not-available-container {\n  border-radius: 32px;\n  padding-top: 7px;\n  padding-right: 16px;\n  padding-bottom: 7px;\n  padding-left: 16px;\n  gap: 8px;\n  background: #fee1e7;\n  justify-content: center;\n}\n.grid-not-available-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 13px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--Colors-Primary-500, #d2042d);\n}\n.grid-price-col {\n  display: flex;\n  gap: 5px;\n  align-items: center;\n}\n.add-grid-views {\n  display: flex;\n}\n\n.grid-view-card {\n  height: 100%;\n  width: 100%;\n}\n.grid-view-card.ant-card .ant-card-body {\n  padding: 0px !important;\n  border-radius: 0 0 8px 8px;\n  height: 100% !important;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.grid-notify-button {\n  margin-top: 0px !important;\n}\n.grid-specification-layout {\n  display: flex;\n  margin-top: 20px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n.spec-icon-row {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 5px;\n}\n.grid-bottom-add {\n  display: flex;\n  width: 100% !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n.grid-product-site-number {\n  padding-right: 2% !important;\n}\n.grid-empty-view-card {\n  display: flex;\n  justify-content: center;\n}\n.available-txt-grid {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 13px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-300, #5b5e5d);\n}\n@media (min-width: 769px) and (max-width: 1025px) {\n  .grid-product-title-available-state {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n  }\n  .grid-not-available-col {\n    width: 100% !important;\n    justify-content: flex-start !important;\n  }\n  .small-screen-container {\n    width: 45%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .notify-me-grid-button {\n    padding: 0px !important;\n  }\n  .grid-pricing-section {\n    gap: 0px !important;\n  }\n  /* .add-grid-views {\n    height: 100% !important;\n  } */\n}\n\n@media (min-width: 1921px) and (max-width: 2560px) {\n  .product-image-wrapper {\n    height: 350px !important;\n  }\n  .carousel-image-slide {\n    height: 350px;\n  }\n  .product-id {\n    font-size: 16px !important;\n  }\n  .product-title-grid {\n    font-size: var(--Font-Font-Size-p, 21px);\n  }\n  .available-txt-grid {\n    font-size: 16px;\n  }\n  .product-availability {\n    font-size: 20px;\n  }\n  .product-size-text {\n    font-size: 20px;\n  }\n  .product-type {\n    font-size: 20px;\n  }\n  .price-text {\n    font-size: 28px;\n  }\n  .per-week {\n    font-size: 18px;\n  }\n}\n@media (min-width: 2561px) and (max-width: 3841px) {\n  .product-image-wrapper {\n    height: 450px !important;\n  }\n  .carousel-image-slide {\n    height: 450px;\n  }\n  .product-id {\n    font-size: 16px !important;\n  }\n  .product-title-grid {\n    font-size: var(--Font-Font-Size-p, 21px);\n  }\n  .available-txt-grid {\n    font-size: 16px;\n  }\n  .product-availability {\n    font-size: 20px;\n  }\n  .product-size-text {\n    font-size: 20px;\n  }\n  .product-type {\n    font-size: 20px;\n  }\n  .price-text {\n    font-size: 28px;\n  }\n  .per-week {\n    font-size: 18px;\n  }\n}\n.product-grid-stretch {\n  height: 100%;\n}\n@media (min-width: 769px) and (max-width: 1025px) {\n  .grid-side {\n    padding: 50px 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
